import React from 'react'
import cn from 'classnames'
import s from './TimelineList.scss'

export default props => {
  const { children, title, className, ...otherProps } = props
  return (
    <div className={cn(s.outer, className)} {...otherProps}>
      {title && <div className={s.title}>{title}</div>}
      <div className={s.list}>{children}</div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/TimelineList/TimelineList.jsx